import { UpdatedDiagnostic } from "@fairfleet/geotab";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { useDiagnosticsByIds } from "@/hooks/diagnostic/useDiagnosticsByIds";
import getObdCode from "@/utilities/codes/getObdCode";

interface Code {
  formattedValue: string;
  type: string;
}

const FaultCodeCell = (params: GridRenderCellParams) => {
  const { row } = params;
  const [code, setCode] = useState<Code | null>(null);
  const { data: diagnosticData, isLoading } = useDiagnosticsByIds([row?.diagnostic?.id]);
  const diagnostic = diagnosticData?.[row?.diagnostic?.id] as UpdatedDiagnostic | undefined;
  useEffect(() => {
    if (isLoading) return;
    switch (diagnostic?.source) {
      case "SourceObdId":
      case "SourceObdSaId":
        setCode({
          formattedValue: getObdCode(diagnostic) ?? "Code not found",
          type: "obd",
        });
        break;
      case "SourceJ1939Id":
        setCode({
          formattedValue: diagnostic?.code != null ? String(diagnostic.code) : "Code not found",
          type: "SPN",
        });
        break;
      default:
        setCode({
          formattedValue: diagnostic?.code != null ? String(diagnostic.code) : "Code not found",
          type: "unkown",
        });
        break;
    }
  }, [diagnostic, isLoading]);

  return (
    <Tooltip title={code?.type}>
      <span>{code?.formattedValue || "---"}</span>
    </Tooltip>
  );
};

export default FaultCodeCell;
